



































import Vue from "vue";
import releaseNotesJson from "@/releaseNotes.json";
import pkg from "../../../package.json";
import { mdiClose } from "@mdi/js";

interface ReleaseDetails {
    releaseDate: string;
    changelog: string[];
}

interface RawRelease {
    0: string;
    1: ReleaseDetails;
}

interface Release {
    version: string;
    date: string;
    changelog: string[];
}

export default Vue.extend({
    data() {
        return {
            releaseNotes: [] as Release[],
            currentVersion: pkg.version,
            openPanels: 0,
            mdiClose,
        };
    },
    mounted() {
        this.loadReleases();
    },
    methods: {
        closeDialog(): void {
            this.$emit("close");
        },
        loadReleases(): void {
            this.releaseNotes = Object.entries(releaseNotesJson)
                .reverse()
                .map((release: RawRelease) => {
                    return {
                        version: release[0],
                        date: this.humanizeDate(release[1].releaseDate),
                        changelog: release[1].changelog,
                    };
                });
        },
        humanizeDate(isoDate: string): string {
            const months = [
                "January",
                "Feburary",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
            ];

            let dateSplit = isoDate.split("-");

            return (
                months[Number(dateSplit[1]) - 1] +
                " " +
                Number(dateSplit[2]) +
                ", " +
                dateSplit[0]
            );
        },
    },
});
